import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "../views/layout/Layout";
import { isMeituanDevUiEnabled } from "@/utils/meituanDevFeature";

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true
  },
  { path: "/404", component: () => import("@/views/404"), hidden: true },
  {
    path: "",
    component: Layout,
    redirect: "/home",
    meta: { title: "首页", icon: "home" },
    children: [
      {
        path: "home",
        name: "home",
        component: () => import("@/views/home/index"),
        meta: { title: "首页", icon: "dashboard" }
      }
    ]
  }
];

const asyncRouterMapBase = [
  {
    path: "/pms",
    component: Layout,
    redirect: "/pms/product",
    name: "pms",
    meta: { title: "商品", icon: "product" },
    children: [
      {
        path: "product",
        name: "product",
        component: () => import("@/views/pms/product/index"),
        meta: { title: "商品列表", icon: "product-list" }
      },
      {
        path: "addProduct",
        name: "addProduct",
        component: () => import("@/views/pms/product/add"),
        meta: { title: "添加商品", icon: "product-add" }
      },
      {
        path: "updateProduct",
        name: "updateProduct",
        component: () => import("@/views/pms/product/update"),
        meta: { title: "修改商品", icon: "product-add" },
        hidden: true
      },
      {
        path: "productCate",
        name: "productCate",
        component: () => import("@/views/pms/productCate/index"),
        meta: { title: "商品分类", icon: "product-cate" }
      },
      {
        path: "addProductCate",
        name: "addProductCate",
        component: () => import("@/views/pms/productCate/add"),
        meta: { title: "添加商品分类" },
        hidden: true
      },
      {
        path: "updateProductCate",
        name: "updateProductCate",
        component: () => import("@/views/pms/productCate/update"),
        meta: { title: "修改商品分类" },
        hidden: true
      },
      {
        path: "productAttr",
        name: "productAttr",
        component: () => import("@/views/pms/productAttr/index"),
        meta: { title: "商品类型", icon: "product-attr" }
      },
      {
        path: "productAttrList",
        name: "productAttrList",
        component: () => import("@/views/pms/productAttr/productAttrList"),
        meta: { title: "商品属性列表" },
        hidden: true
      },
      {
        path: "addProductAttr",
        name: "addProductAttr",
        component: () => import("@/views/pms/productAttr/addProductAttr"),
        meta: { title: "添加商品属性" },
        hidden: true
      },
      {
        path: "updateProductAttr",
        name: "updateProductAttr",
        component: () => import("@/views/pms/productAttr/updateProductAttr"),
        meta: { title: "修改商品属性" },
        hidden: true
      },
      {
        path: "brand",
        name: "brand",
        component: () => import("@/views/pms/brand/index"),
        meta: { title: "品牌管理", icon: "product-brand" }
      },
      {
        path: "addBrand",
        name: "addBrand",
        component: () => import("@/views/pms/brand/add"),
        meta: { title: "添加品牌" },
        hidden: true
      },
      {
        path: "updateBrand",
        name: "updateBrand",
        component: () => import("@/views/pms/brand/update"),
        meta: { title: "编辑品牌" },
        hidden: true
      }
    ]
  },
  {
    path: "/oms",
    component: Layout,
    redirect: "/oms/order",
    name: "oms",
    // 与酒店管理 /hms 一致：不设 alwaysShow，由侧栏在「仅一个可见子菜单」时自动拍平为单一项
    meta: { title: "订单管理", icon: "product" },
    children: [
      {
        path: "order",
        name: "order",
        component: () => import("@/views/oms/order/index"),
        meta: { title: "订单列表", icon: "product-list" }
      },
      {
        path: "holdOrderList",
        name: "holdOrderList",
        component: () => import("@/views/oms/order/holdOrderList"),
        meta: { title: "Hold房单列表", icon: "product-list" }
      },
      {
        path: "workOrderList",
        name: "workOrderList",
        component: () => import("@/views/oms/order/workOrderList"),
        meta: { title: "工单列表", icon: "product-list" }
      },
      {
        path: "afterSalesList",
        name: "afterSalesList",
        component: () => import("@/views/oms/order/afterSalesList"),
        meta: { title: "售后单列表", icon: "product-list" }
      },
      {
        path: "orderStats",
        name: "orderStats",
        component: () => import("@/views/oms/order/orderStats"),
        meta: { title: "订单统计", icon: "product-list" }
      },
      {
        path: "mailCenter",
        name: "mailCenter",
        component: () => import("@/views/oms/order/mailCenter"),
        meta: { title: "邮件中心", icon: "product-list" }
      },
      {
        path: "orderDetail",
        name: "orderDetail",
        component: () => import("@/views/oms/order/orderDetail"),
        meta: { title: "订单详情" },
        hidden: true
      },
      {
        path: "createWorkOrder",
        name: "createWorkOrder",
        component: () => import("@/views/oms/order/createWorkOrder"),
        meta: { title: "创建工单" },
        hidden: true
      },
      {
        path: "addOrder",
        name: "addOrder",
        component: () => import("@/views/oms/order/add"),
        meta: { title: "添加订单" },
        hidden: true
      }
    ]
  },
  {
    path: "/ums",
    component: Layout,
    redirect: "/ums/admin",
    name: "ums",
    meta: { title: "权限", icon: "ums" },
    children: [
      {
        path: "admin",
        name: "admin",
        component: () => import("@/views/ums/admin/index"),
        meta: { title: "用户列表", icon: "ums-admin" }
      },
      {
        path: "opDuty",
        name: "umsOpDuty",
        component: () => import("@/views/ums/opDuty/index"),
        meta: { title: "OP上下班", icon: "el-icon-time" }
      },
      {
        path: "role",
        name: "role",
        component: () => import("@/views/ums/role/index"),
        meta: { title: "角色列表", icon: "ums-role" }
      },
      {
        path: "allocMenu",
        name: "allocMenu",
        component: () => import("@/views/ums/role/allocMenu"),
        meta: { title: "分配菜单" },
        hidden: true
      },
      {
        path: "allocResource",
        name: "allocResource",
        component: () => import("@/views/ums/role/allocResource"),
        meta: { title: "分配资源" },
        hidden: true
      },
      {
        path: "menu",
        name: "menu",
        component: () => import("@/views/ums/menu/index"),
        meta: { title: "菜单列表", icon: "ums-menu" }
      },
      {
        path: "addMenu",
        name: "addMenu",
        component: () => import("@/views/ums/menu/add"),
        meta: { title: "添加菜单" },
        hidden: true
      },
      {
        path: "updateMenu",
        name: "updateMenu",
        component: () => import("@/views/ums/menu/update"),
        meta: { title: "修改菜单" },
        hidden: true
      },
      {
        path: "resource",
        name: "resource",
        component: () => import("@/views/ums/resource/index"),
        meta: { title: "资源列表", icon: "ums-resource" }
      },
      {
        path: "openApiAudit",
        name: "hmsOpenApiAudit",
        component: () => import("@/views/hms/openApiAudit/index"),
        meta: { title: "接口操作记录", icon: "product-list" }
      },
      {
        path: "resourceCategory",
        name: "resourceCategory",
        component: () => import("@/views/ums/resource/categoryList"),
        meta: { title: "资源分类" },
        hidden: true
      }
    ]
  },
  {
    path: "/hms",
    component: Layout,
    redirect: "/hms/hotel",
    name: "hms",
    meta: { title: "酒店管理", icon: "product" },
    children: [
      {
        path: "hotel",
        name: "hotel",
        component: () => import("@/views/hms/hotel/index"),
        meta: { title: "酒店列表", icon: "product-list" }
      },
      {
        path: "hotel/detail/:id",
        name: "hotelDetail",
        component: () => import("@/views/hms/hotel/detail"),
        meta: { title: "酒店详情" },
        hidden: true
      },
      {
        path: "dida-ebk-mapping",
        name: "didaEbkMapping",
        component: () => import("@/views/hms/didaEbkMapping/index"),
        meta: { title: "道旅EBK匹配列表", icon: "product-list" }
      },
      {
        path: "currency",
        name: "currency",
        component: () => import("@/views/hms/currency/index"),
        meta: { title: "币种管理", icon: "product-brand" }
      },
      {
        path: "currency/china-rate-table",
        name: "currencyChinaRateTable",
        component: () => import("@/views/hms/currency/chinaRateTable"),
        meta: { title: "中国汇率表" },
        hidden: true
      },
      {
        path: "channel",
        name: "channel",
        component: () => import("@/views/hms/channel/index"),
        meta: { title: "渠道列表", icon: "product-brand" }
      },
      {
        path: "brg-name",
        name: "brgNameConfig",
        component: () => import("@/views/hms/brgName/index"),
        meta: { title: "测试单姓名配置", icon: "product-list" }
      },
    ]
  },
  {
    path: "/fin",
    component: Layout,
    redirect: "/fin/ap",
    name: "fin",
    meta: { title: "财务管理", icon: "order" },
    children: [
      {
        path: "apply",
        name: "apply",
        component: () => import("@/views/fin/apply/index"),
        meta: { title: "付款申请", icon: "product-add" }
      },
      {
        path: "ap",
        name: "ap",
        component: () => import("@/views/fin/ap/index"),
        meta: { title: "应付款管理", icon: "product-list" }
      },
      {
        path: "apDetail",
        name: "apDetail",
        component: () => import("@/views/fin/ap/detail"),
        meta: { title: "账单流水详情" },
        hidden: true
      }
    ]
  },
  { path: "*", redirect: "/404", hidden: true }
];

/** 仅开发环境注册：供应商直连侧栏（美团 + 悦途联调页） */
export const meituanAsyncRoutes = [
  {
    path: "/meituan",
    component: Layout,
    redirect: "/meituan/playground",
    name: "meituanDirect",
    alwaysShow: true,
    meta: { title: "供应商直连", icon: "product" },
    children: [
      {
        path: "catalog",
        name: "meituanApiCatalog",
        component: () => import("@/views/meituan/MeituanApiCatalog"),
        meta: { title: "美团入站接口目录", icon: "product-list" }
      },
      {
        path: "playground",
        name: "meituanPlayground",
        component: () => import("@/views/meituan/MeituanDirectDebug"),
        meta: { title: "美团联调工作台", icon: "product-list" }
      },
      {
        path: "yuetutianxia",
        name: "yuetutianxiaPlayground",
        component: () => import("@/views/yuetutianxia/YuetutianxiaDirectDebug"),
        meta: { title: "悦途联调工作台", icon: "product-list" }
      },
      {
        path: "dida",
        name: "didaPlayground",
        component: () => import("@/views/dida/DidaDirectDebug"),
        meta: { title: "道旅联调工作台", icon: "product-list" }
      },
      {
        path: "tongcheng",
        name: "tongchengPlayground",
        component: () => import("@/views/tongcheng/TongchengDirectDebug"),
        meta: { title: "同程联调工作台", icon: "product-list" }
      },
      {
        path: "fliggy",
        name: "fliggyPlayground",
        component: () => import("@/views/fliggy/FliggyDirectDebug"),
        meta: { title: "飞猪联调工作台", icon: "product-list" }
      }
    ]
  }
];

export const asyncRouterMap = isMeituanDevUiEnabled()
  ? (() => {
      const routes = asyncRouterMapBase.slice();
      const umsIndex = routes.findIndex(r => r.name === "ums");
      const insertAt = umsIndex >= 0 ? umsIndex : routes.length - 1;
      routes.splice(insertAt, 0, ...meituanAsyncRoutes);
      return routes;
    })()
  : asyncRouterMapBase;

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
});



// WEBPACK FOOTER //
// ./src/router/index.js